// Theme configuration for multi-tenant branding
// This configuration allows easy customization of logos, colors, and other branding elements per tenant

const themes = {
  initio: {
    logo: 'initio-logo.svg',
    logoType: 'svg',
    favicon: 'favicon.ico',
    colors: {}, // Ready for future color customization
    name: 'Initio',
    title: 'Initio Software',
  },
  redwoodseed: {
    logo: 'redwoodseed-logo.png',
    logoType: 'png',
    favicon: 'redwoodlogo.png',
    colors: {}, // Ready for future color customization
    name: 'Redwoodseed',
    title: 'Redwood Valuation',
  },
};

export default themes;

